import { render, staticRenderFns } from "./CoreHRCertificates.vue?vue&type=template&id=1d9c8743"
import script from "./CoreHRCertificates.vue?vue&type=script&lang=js"
export * from "./CoreHRCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports